import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import css from './index.styl?inline';
import template from './index.jade';

export class Switch extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      disabled: `boolean`,
      on: `boolean`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        on: false,
        disabled: false,
      },
      helpers: {
        toggleSwitch: () => {
          this.dispatchEvent(new CustomEvent(`change`, {detail: {on: !this.state.on}}));
        },
      },
    };
  }

  attributeChangedCallback(attr) {
    super.attributeChangedCallback(...arguments);
    if (attr === `on`) {
      this.update({on: this.attr(`on`)});
    } else if (attr === `disabled`) {
      this.update({disabled: this.attr(`disabled`)});
    }
  }
}

export const SwitchEl = defineAndMakeJsxFactory(`mp-switch`, Switch);
